import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (totalHeight <= 0) {
        setScrollProgress(0);
        setShowButton(false);
        return;
      }
      const currentProgress = Math.min((window.scrollY / totalHeight) * 100, 100);
      setScrollProgress(currentProgress);
      setShowButton(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Scroll Progress Bar */}
      <div
        className="fixed top-0 left-0 z-[60] h-[3px] bg-primary-500 transition-all duration-150 ease-out"
        style={{ width: `${scrollProgress}%` }}
      />

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-24 md:bottom-6 right-5 md:right-6 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-foreground-50 hover:bg-primary-600 cursor-pointer transition-all duration-300 ${
          showButton
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="Nazaj na vrh"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </>
  );
}